var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from "react-query";
import { shouldFetchExactCount } from "../utils/exactCount";
// Separate query keyed without offset: setTotalRecords from the list query's onSuccess would overwrite the exact number back to the cap on the next page fetch.
export var useExactTotalCount = function (_a) {
    var queryKey = _a.queryKey, fetchTotalRecords = _a.fetchTotalRecords, totalRecordsExact = _a.totalRecordsExact;
    // Marker as key suffix so existing prefix-based invalidateQueries calls hit this query too
    var data = useQuery(__spreadArray(__spreadArray([], queryKey, true), ["exactTotalCount"], false), fetchTotalRecords, { enabled: shouldFetchExactCount(totalRecordsExact) }).data;
    return data;
};
